// turbolinkを有効にしていれば、この行にrequire("turbolinks").start()
require("@rails/activestorage").start() //activeStrorage周りのjs
require("@rails/actiontext")
require("channels")

import "controllers"
